<template>
	<div style="display: flex; flex-direction: column; margin-left: 25px; margin-right: 25px; margin-top: 20px;">
		<div class="miniCard"
			style="background: RGBA(236, 240, 243, 1); border-radius: 16px; display: flex; flex-direction: column;" :style="{boxShadow: !isPdfShow ? '5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF' : '', background: !isPdfShow ? ' RGBA(236, 240, 243, 1)' : '#E0E6EF'}">
			<div class="miniCardTop" @click="unflodClick" style="cursor: pointer;">
				<div style="display: flex; width: 100%; height: 34px;">
					<div style="display: flex; flex: 1;">
						<img style="width: 28px; height: 28px; margin-left: 15px; border-radius: 10px; margin-top: 3px;"
							:src="data && data.icon ? require('../../../assets/' + data.icon + '.png') : ''" alt="">
						<div style="margin-left: 10px; position: relative; margin-top: 3px;">
							<div v-html="$options.filters.reMate(data && data.titleLabel ? data.titleLabel : ' ')"></div>
							<div v-if="type != 1"
								style="position: absolute; bottom: 4px; width: 47px; height: 8px; background: linear-gradient(270deg, rgba(24,144,255,0) 0%, rgba(255,113,134,0) 0%, #FF7186 100%); border-radius: 5px; opacity: 0.3;">
							</div>
							<div v-if="type == 1"
								style="position: absolute; bottom: 4px; width: 47px; height: 8px; background: linear-gradient( 270deg, rgba(74,124,232,0) 0%, #4A7CE8 100%); border-radius: 5px; opacity: 0.3;">
							</div>
						</div>
						<QuestionMarkA v-if="data && data.index == 'ahi'" />
					</div>
					<div style="width: 34px; height: 34px; display: flex; justify-content: center; align-items: center;">
						<div :class="isUnfold ? 'unfoldImgTrue' : 'unfoldImgFalse'" style="width: 14px; height: 14px;">
						</div>
					</div>
				</div>
				<div v-if="descs" v-for="(kItem, kIndex) in descs" :key="kIndex" style="font-size: 16px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #A4ABB6; line-height: 22px; margin-left: 53px; margin-right: 49px; margin-top: 1px; white-space: pre-wrap" v-html="kItem ? kItem : ' '" :style="{marginTop: kIndex > 0 ? '5px' : '1px'}"></div>
			</div>
			<div v-show="isUnfold"
				style="background: rgba(255,255,255,0.85); margin-left: 5px; margin-right: 5px; margin-bottom: 5px; border-radius: 12px; padding-top: 5px; padding-bottom: 5px;">
				
				<div class="leaveBed" style="display: flex; flex: 1; padding-left: 15px; padding-right: 15px; margin-top: 10px; margin-bottom: 10px;">
					<div style="display: flex; flex-direction: column; flex: 1;">
						<div style="height: 70px; background: #F3F4F7; border-radius: 4px; display: flex;">
							<div  v-if="leaveLeftData && leaveLeftData.data && leaveLeftData.data[leaveSelectIndex] && leaveLeftData.data[leaveSelectIndex].extendData" style="width: 6px; height: 6px; border-radius: 5px; margin-top: 22px; margin-left: 15px;" :style="{ background: leaveLeftData.data[leaveSelectIndex].extendData.deviateFlag == 1 ? 'rgba(255, 113, 134, 1)' : (leaveLeftData.data[leaveSelectIndex].extendData.deviateFlag == 2 ? 'rgba(74, 124, 232, 1)' : 'rgba(165, 169, 188, 1)') }"></div>
							<div style="margin-left: 5px; margin-right: 15px; margin-top: 15px; flex: 1;">
								<div v-if="leaveLeftData && leaveLeftData.data && leaveLeftData.data[leaveSelectIndex] && leaveLeftData.data[leaveSelectIndex].extendData" v-html="$options.filters.newReMate((leaveLeftData.data[leaveSelectIndex].extendData.date + '：' + leaveLeftData.data[leaveSelectIndex].extendData.deviateDescLabel) || '')"></div>
							</div>
						</div>
						<div style="height: 457px; display: flex; flex-direction: column; position: relative;">
							<div style="position: absolute; left: 0px; right: 0px; top: 10px; height: 102px; border-radius: 4px; border: 1px solid #E4E5EA;  pointer-events: none; z-index: 1;"></div>
							<div style="position: absolute; left: 0px; right: 0px; top: 144px; height: 313px; border-radius: 4px; border: 1px solid #E4E5EA;  pointer-events: none; z-index: 1;"></div>
							<div style="position: absolute; background: rgba(243, 244, 247, 1); width: 17px; top: 11px; bottom: 0px; left: 150px; z-index: 0;  pointer-events: none;" :style="{ left: leaveSingleWidth * leaveSelectIndex + 'px', width: leaveSingleWidth + 'px' }"></div>
							<div v-if="leaveHoverindex != undefined" style="border-left: 1px dashed rgba(164, 189, 243, 1); text-align: center; position: absolute; top: 11px; height: 101px; width: 1px; z-index: 10;  pointer-events: none;" :style="{ left: leaveSingleWidth * leaveHoverindex + (leaveSingleWidth / 2.0) + 'px' }"></div>
							<div v-if="leaveHoverindex != undefined" style="border-left: 1px dashed rgba(164, 189, 243, 1); text-align: center; position: absolute; top: 144px; bottom: 2px; width: 1px; z-index: 10;  pointer-events: none;" :style="{ left: leaveSingleWidth * leaveHoverindex + (leaveSingleWidth / 2.0) + 'px' }"></div>
							<div style="height: 10px; position: relative;  pointer-events: none;">
								<div style="width: 19px; height: 10px; position: absolute; left: 100px; top: 0px; display: flex;" :style="{ left: leaveSingleWidth * leaveSelectIndex + ((leaveSingleWidth - 19) / 2.0) + 'px' }">
									<img style="width: 19px; height: 10px;" src="../../../assets/icon_portrait_arrow_2.png" alt="" />
								</div>
							</div>
							<div style="position: absolute; top: 150px; bottom: 0px; z-index: 1; pointer-events: none;" :style="{ width: leaveSingleWidth + 'px', left: leaveSingleWidth * leaveSelectIndex + 'px'} ">
								<div  v-for="(item, index) in leaveWranningTips || []" style="position: absolute;" :style="{ left: leaveSelectIndex <= 15 ?  leaveSingleWidth + 'px' : 'unset', right: leaveSelectIndex > 15 ? leaveSingleWidth + 'px' : 'unset', top: item.top }">
									<div style="display: flex; align-items: center;">
										<img v-if="leaveSelectIndex <= 15"  style="width: 6px; height: 10px; margin-right: -1px; z-index: 1;" src="../../../assets/icon_portrait_tip_alert_arrow_left.png" alt="">
										<div style="background: rgba(254,228,228,0.5); border: 1px solid rgba(255,113,134,0.3); display: flex; align-items: center;  padding: 10px; border-radius: 5px; z-index: 0;">
											<div style="width: 6px; height: 6px; background: rgba(255, 113, 134, 1); border-radius: 3px; margin-right: 5px;"></div>
											<div style="white-space: nowrap" v-html="$options.filters.newReMate(item.floatingWinTips || '')"></div>
										</div>
										<img v-if="leaveSelectIndex > 15" style="width: 6px; height: 10px; margin-left: -1px; z-index: 1;" src="../../../assets/icon_portrait_tip_alert_arrow_right.png" alt="">
									</div>
								</div>
							</div>
							<div style="height: 102px; border-radius: 4px; display: flex;">
								<div style="height: 102px; width: 100%;">
									<div :id="'echartsLeaveBedTop1' + this.$props.data.index" style="height: 102px;"></div>
								</div>
							</div>
							<div style="height: 32px; display: flex; z-index: 1">
								<div v-for="(item, index) in leaveLeftData && leaveLeftData.xaxis ? leaveLeftData.xaxis : []" style="flex: 1; display: flex; justify-content: center; align-items: center; font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 10px; color: #A5A9BC; line-height: 14px; cursor: pointer;" @click="leaveChangeDateClick(index)">
									<div style="width: 16px; height: 16px; font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 10px; color: #A5A9BC; line-height: 14px; display: flex; justify-content: center; align-items: center; border-radius: 8px;" :style="{ color: leaveSelectIndex == index ? '#FFFFFF' : leaveHoverindex == index ? 'rgba(94, 103, 121, 1)' : 'rgba(165, 169, 188, 1)', fontSize: (leaveSelectIndex == index || leaveHoverindex == index) ? '600' : '400', background: leaveSelectIndex == index ? '#5E6779' : '#FFFFFF00' }">{{ item }}</div>
								</div>
							</div>
							<div style="height: 313px; border-radius: 4px;">
								<div style="height: 313px;">
									<div :id="'echartsLeaveBedBottom1' + this.$props.data.index" style="height: 313px;"></div>
								</div>
							</div>
							
						</div>
					</div>
					<div v-if="leaveIsShowRightCharts" style="width: 230px; margin-left: 10px; display: flex; flex-direction: column;">
						<div v-if="leaveRightData && !leaveRightData.normalCntWarn" style="background: #F6F9FF; border-radius: 4px; border: 1px solid #E4ECFD; position: relative; height: 86px;">
							<div style="display: flex; margin-left: 15px; margin-top: 6px;">
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 12px; color: rgba(131, 148, 185, 0.7); line-height: 17px; margin-top: 9px;">日常每晚离床：</div>
								<div style="font-family: DINAlternate-Bold,DINAlternate; font-weight: 400; font-size: 24px; color: #8394B9; line-height: 28px;">{{ leaveRightData.normalCnt }}</div>
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 12px; color: rgba(131, 148, 185, 0.7); line-height: 17px; margin-top: 9px;">次左右</div>
							</div>
							<div style="display: flex; background: rgba(131, 148, 185, 0.1); align-items: center; margin-left: 15px; margin-top: 3px; margin-bottom: 15px; margin-right: 15px;">
								<div style="width: 4px; height: 34px; background: rgba(131, 148, 185, 0.5); margin-right: 6px;"></div>
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #8394B9; line-height: 20px;">{{ leaveRightData.normalCntCon }}</div>
							</div>
							<div style="position: absolute; left: 3px; bottom: 3px; background: rgba(131, 148, 185, 0.1); width: 8px; height: 8px; border-radius: 4px;"></div>
							<div style="position: absolute; right: 3px; bottom: 3px; background: rgba(131, 148, 185, 0.1); width: 8px; height: 8px; border-radius: 4px;"></div>
						</div>
						<div v-if="leaveRightData && leaveRightData.normalCntWarn" style="background: #FFF8FB; border-radius: 4px; border: 1px solid #FED3D9; position: relative; height: 86px;">
							<div style="display: flex; margin-left: 15px; margin-top: 6px;">
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 12px; color: rgba(255, 113, 134, 0.7); line-height: 17px; margin-top: 9px;">日常每晚离床：</div>
								<div style="font-family: DINAlternate-Bold,DINAlternate; font-weight: 400; font-size: 24px; color: rgba(255, 113, 134, 1); line-height: 28px;">{{ leaveRightData.normalCnt }}</div>
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 12px; color: rgba(255, 113, 134, 0.7); line-height: 17px; margin-top: 9px;">次左右</div>
							</div>
							<div style="display: flex; background: rgba(255, 209, 215, 0.3); align-items: center; margin-left: 15px; margin-top: 3px; margin-bottom: 15px; border: 1px solid rgba(255, 184, 195, 0.3); margin-right: 15px;">
								<div style="width: 4px; height: 34px; background: rgba(255, 113, 134, 0.5); margin-right: 6px;"></div>
								<img style="width: 14px; height: 14px; margin-right: 5px;" src="../../../assets/icon_portrait_wranning_1.png" alt="">
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(94, 103, 121, 1); line-height: 20px;">{{ leaveRightData.normalCntCon }}</div>
							</div>
							<div style="position: absolute; left: 3px; bottom: 3px; background: rgba(131, 148, 185, 0.1); width: 8px; height: 8px; border-radius: 4px;"></div>
							<div style="position: absolute; right: 3px; bottom: 3px; background: rgba(131, 148, 185, 0.1); width: 8px; height: 8px; border-radius: 4px;"></div>
						</div>
						<div style="display: flex; justify-content: space-between; padding-top: 1px; padding-bottom: 1px; padding-left: 6px; padding-right: 6px;">
							<div style="width: 2px; height: 8px; background: rgba(131, 148, 185, 0.3)"></div>
							<div style="width: 2px; height: 8px; background: rgba(131, 148, 185, 0.3)"></div>
						</div>
						<div v-if="leaveRightData && !leaveRightData.normalDurationWarn" style="background: #F6F9FF; border-radius: 4px; border: 1px solid #E4ECFD; position: relative; height: 86px;">
							<div style="display: flex; margin-left: 15px; margin-top: 6px;">
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 12px; color: rgba(131, 148, 185, 0.7); line-height: 17px; margin-top: 9px;">日常每次离床：</div>
								<div style="font-family: DINAlternate-Bold,DINAlternate; font-weight: 400; font-size: 24px; color: #8394B9; line-height: 28px;">{{ leaveRightData.normalDuration }}</div>
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 12px; color: rgba(131, 148, 185, 0.7); line-height: 17px; margin-top: 9px;">分钟左右</div>
							</div>
							<div style="display: flex; background: rgba(131, 148, 185, 0.1); align-items: center; margin-left: 15px; margin-top: 3px; margin-bottom: 15px; margin-right: 15px;">
								<div style="width: 4px; height: 34px; background: rgba(131, 148, 185, 0.5); margin-right: 6px;"></div>
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #8394B9; line-height: 20px;">{{ leaveRightData.normalDurationCon }}</div>
							</div>
							<div style="position: absolute; left: 3px; top: 3px; background: rgba(131, 148, 185, 0.1); width: 8px; height: 8px; border-radius: 4px;"></div>
							<div style="position: absolute; right: 3px; top: 3px; background: rgba(131, 148, 185, 0.1); width: 8px; height: 8px; border-radius: 4px;"></div>
						</div>
						<div v-if="leaveRightData && leaveRightData.normalDurationWarn" style="background: #FFF8FB; border-radius: 4px; border: 1px solid #FED3D9; position: relative; height: 86px;">
							<div style="display: flex; margin-left: 15px; margin-top: 6px;">
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 12px; color: rgba(255, 113, 134, 0.7); line-height: 17px; margin-top: 9px;">日常每次离床：</div>
								<div style="font-family: DINAlternate-Bold,DINAlternate; font-weight: 400; font-size: 24px; color: rgba(255, 113, 134, 1); line-height: 28px;">{{ leaveRightData.normalDuration }}</div>
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 12px; color: rgba(255, 113, 134, 0.7); line-height: 17px; margin-top: 9px;">分钟左右</div>
							</div>
							<div style="display: flex; background: rgba(255, 209, 215, 0.3); align-items: center; margin-left: 15px; margin-top: 3px; margin-bottom: 15px; border: 1px solid rgba(255, 184, 195, 0.3); margin-right: 15px;">
								<div style="width: 4px; height: 32px; background: rgba(255, 113, 134, 0.5); margin-right: 6px;"></div>
								<img style="width: 14px; height: 14px; margin-right: 5px;" src="../../../assets/icon_portrait_wranning_1.png" alt="">
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(94, 103, 121, 1); line-height: 20px;">{{ leaveRightData.normalDurationCon }}</div>
							</div>
							<div style="position: absolute; left: 3px; top: 3px; background: rgba(131, 148, 185, 0.1); width: 8px; height: 8px; border-radius: 4px;"></div>
							<div style="position: absolute; right: 3px; top: 3px; background: rgba(131, 148, 185, 0.1); width: 8px; height: 8px; border-radius: 4px;"></div>
						</div>
						<div style="display: flex; align-items: center; margin-top: 10px; margin-bottom: 5px;">
							<img style="width: 10px; height: 8px; margin-left: 38px; margin-right: 6px;" src="../../../assets/icon_portrait_arrow_1.png" alt="">
							<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 12px; color: #5E6779; line-height: 17px;">最近30天每小时离床情况</div>
						</div>
						<div style="height: 313px; position: relative; display: flex;">
							<div style="position: absolute; left: 34px; right: 0px; top: 0px; bottom: 0px; border: 1px solid #FFFFFF; z-index: 1;"></div>
							<div style="position: absolute; left: 34px; right: 0px; top: 0px; bottom: 0px; border: 1px solid #E4E5EA; border-radius: 4px; z-index: 2;"></div>
							<div style="width: 30px; height: 100%; display: flex; flex-direction: column; justify-content: space-between; padding: 18px 0px;">
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 10px; color: #A5A9BC; line-height: 14px;" v-for="(mItem, mIndex) in thirtyDayArr">{{mItem}}</div>
							</div>
							<div style="flex: 1;">
								<div :id="'echart_last_thirty_day_leave_bed' + this.$props.data.index" style="width: 200px; height: 313px; z-index: 3;"></div>
							</div>
						</div>
					</div>
				</div>
				
				
				
				
				
				
				<!-- <div v-if="data && data.subTitle" style="display: flex; align-items: center; margin-bottom: 10px; margin-top: 15px;">
					<div style="width: 4px; height: 14px; background: #4A7CE8; border-radius: 2px; margin-left: 15px;">
					</div>
					<div
						style="font-size: 16px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 22px; margin-left: 10px;">
						{{ data && data.subTitle ? data.subTitle : ' ' }}</div>
					<QuestionMarkB v-if="data && data.index == 'bmRatio2Num'" />
				</div>
				<div v-if="data && (data.leftTip || data.rightTip)" style="display: flex; align-items: center; margin-top: 10px;">
					<div v-if="data && data.leftTip" style="width: 16px; height: 5px; background: rgba(24,144,255,0.15); margin-left: 15px; border: 1px dotted #4A7CE8;"></div>
					<div
						style="font-size: 12px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #A5A9BC; line-height: 17px; margin-left: 4px;">
						{{ data && data.leftTip ? data.leftTip : ' ' }}</div>
					<div
						style="font-size: 12px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #A5A9BC; line-height: 17px; flex: 1; text-align: right; margin-right: 15px;">
						{{ data && data.rightTip ? data.rightTip : ' ' }}</div>
				</div>
				<div :id="echartId" style="height: 165px;"></div> -->


				<div v-if="data && data.descLabel"
					style="background: linear-gradient(225deg, rgba(148,192,249,0.1) 0%, rgba(173,195,243,0.1) 100%); border-radius: 8px; border: 2px rgba(74, 124, 232, 0.1) solid; margin-left: 15px; margin-right: 15px; padding: 15px; margin-bottom: 10px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 21px;">
					{{ data && data.descLabel ? data.descLabel : ' '  }}</div>
			</div>
		</div>
	</div>
</template>
  
<script>
import portFn from '../../../utils/PortraitFunction.js';
import CustomRichText from '../../../utils/CustomRichText.js';
import QuestionMarkA from '../component/questionMarkA.vue'
import QuestionMarkB from '../component/questionMarkB.vue'

export default {
	components: {
		QuestionMarkA,
		QuestionMarkB
	},
	filters: {
		reMate(val) {
			return CustomRichText.reMateNew(portFn.function_reg_str_to_arr(val))
		},
		newReMate(val) {
			return CustomRichText.reMate(portFn.function_reg_str_to_arr(val))
		},
	},
	props: {
		data: null,
		echartId: {
			type: String,
			default: null,
		},
		option: {
			type: Object,
			default: null
		},
		isPdfShow: {
			type: Boolean,
			default: false
		},
		isFold: {
			type: Boolean,
			default: false
		},
		type: {
			type: Number,
			default: 0 // 0 - 红色，1 - 黄色
		}
	},
	watch: {
		option(newVal, oldVal) {
			if (newVal) {
				let option = newVal;
				this.myChart_Bar = this.$echarts.init(document.getElementById(this.$props.echartId), null, { renderer: 'svg' });
				this.myChart_Bar.setOption(option, true);
				window.addEventListener('resize', () => {
					this.myChart_Bar.resize();
				});
				this.$forceUpdate()
			}
		}
	},
	data() {
		return {
			isUnfold: true,
			// 复杂图表相关
			leaveSelectIndex: undefined,
			leaveWidth: 570,
			leaveSingleWidth: 19,
			leaveHoverindex: undefined,
			leaveIsShowRightCharts: true,
			leaveLeftData: null,
			leaveRightData: null,
			leaveWranningTips: [],
			descs: null,
			thirtyDayArr: ["20:30", "21:30", "22:30", "23:30", "00:30", "01:30", "02:30", "03:30", "04:30", "05:30", "06:30", "07:30"]
		};
	},
	created() { },
	mounted() {
		if (this.$props.data && this.$props.data.conclusion && (this.$props.data.conclusion.indexOf('<br/>') >= 0 || this.$props.data.conclusion.indexOf('<br />') >= 0)) {
			let result; 
			if (this.$props.data.conclusion.indexOf('<br/>') >= 0) {
				result = this.$props.data.conclusion.split("<br/>");
			} else {
				result = this.$props.data.conclusion.split("<br />");
			}
			this.descs = result;
		} else {
			if (this.$props.data && this.$props.data.conclusion) {
				this.descs = [this.$props.data.conclusion];
			} else {
				this.descs = null;
			}
		}

		this.leaveIsShowRightCharts = true;

		if (this.$props.isFold == true) {
			this.isUnfold = false;
		}
		if (this.$props.option) {
			let option = this.$props.option;
			this.myChart_Bar = this.$echarts.init(document.getElementById(this.$props.echartId), null, { renderer: 'svg' });
			this.myChart_Bar.setOption(option, true);
			window.addEventListener('resize', () => {
				this.myChart_Bar.resize();
			});
			this.$forceUpdate()
		}

		if (this.$props.data && this.$props.data.originalData && this.$props.data.originalData.extendData && this.$props.data.originalData.extendData.secretsLeaveBedAbnormal) {
			this.leaveLeftData = JSON.parse(JSON.stringify(this.$props.data.originalData.extendData.secretsLeaveBedAbnormal))
		} else {
			this.leaveLeftData = null
		}
		if (this.$props.data && this.$props.data.originalData && this.$props.data.originalData.extendData && this.$props.data.originalData.extendData.secretsLeaveBedBaseline) {
			this.leaveRightData = JSON.parse(JSON.stringify(this.$props.data.originalData.extendData.secretsLeaveBedBaseline))
			this.leaveWidth = 540;
			this.leaveSingleWidth = 18;
		} else {
			this.leaveWidth = 780;
			this.leaveSingleWidth = 26;
			this.leaveRightData = null
		}

		this.initLeaveCharts();

		if (this.$props.data && this.$props.data.originalData && this.$props.data.originalData.extendData && this.$props.data.originalData.extendData.secretsLeaveBedBaseline) {
			this.leaveIsShowRightCharts = true;
		} else {
			this.leaveIsShowRightCharts = false;
		}

		if (this.leaveIsShowRightCharts == true) {
			// 最近30天每小时离床情况 - 图表
			if (this.leaveIsShowRightCharts == true) {
				this.setEchartLastThirtyDayLeaveBed();
			}

			// 每晚睡眠间离床情况 - 图表
			this.setEchartLeaveBed();
		} else {
			setTimeout(() => {
				// 最近30天每小时离床情况 - 图表
				if (this.leaveIsShowRightCharts == true) {
					this.setEchartLastThirtyDayLeaveBed();
				}

				// 每晚睡眠间离床情况 - 图表
				this.setEchartLeaveBed();
			}, 1000);
		}
		

	},
	methods: {
		initLeaveCharts() {
			let that = this;

			this.echartsLeaveBedTop1 = this.$echarts.init(document.getElementById('echartsLeaveBedTop1' + this.$props.data.index, ), null, { renderer: 'svg' });
			// 柱子点击事件
			this.echartsLeaveBedTop1.on('click', function (params) {
				that.leaveSelectIndex = params.dataIndex;
				that.setEchartLeaveBed();
				// console.log('========', '点击了某根柱子', params)
			});
			// 柱子hover事件
			this.echartsLeaveBedTop1.on('mouseover', function (params) {
				if (params.componentType === 'series') {
					var dataIndex = params.dataIndex;
					// 你可以在这里编写你的逻辑，例如：
					// console.log('Hovering over data index: ' + dataIndex);
					that.leaveHoverindex = dataIndex;
				}
			});
			this.echartsLeaveBedTop1.on('mouseout', function (params) {
				if (params.componentType === 'series') {
					var dataIndex = params.dataIndex;
					// 你可以在这里编写你的逻辑，例如：
					// console.log('Mouse out of data index: ' + dataIndex);
					// that.leaveHoverindex = undefined;
				}
			});


			this.echartsLeaveBedBottom1 = this.$echarts.init(document.getElementById('echartsLeaveBedBottom1' + this.$props.data.index), null, { renderer: 'svg' });
			// 柱子点击事件
			this.echartsLeaveBedBottom1.on('click', function (params) {
				that.leaveSelectIndex = params.dataIndex;
				that.setEchartLeaveBed();
				// console.log('========', '点击了某根柱子', params)
			});
			// 柱子hover事件
			this.echartsLeaveBedBottom1.on('mouseover', function (params) {
				if (params.componentType === 'series') {
					var dataIndex = params.dataIndex;
					// 你可以在这里编写你的逻辑，例如：
					// console.log('Hovering over data index: ' + dataIndex);
					that.leaveHoverindex = dataIndex;
				}
			});
			this.echartsLeaveBedBottom1.on('mouseout', function (params) {
				if (params.componentType === 'series') {
					var dataIndex = params.dataIndex;
					// 你可以在这里编写你的逻辑，例如：
					// console.log('Mouse out of data index: ' + dataIndex);
					// that.leaveHoverindex = undefined;
				}
			});

			this.lastThirtyDayLeaveBedCharts = this.$echarts.init(document.getElementById('echart_last_thirty_day_leave_bed' + this.$props.data.index), null, { renderer: 'svg' });


			window.addEventListener('resize', () => {
				if (this.echartsLeaveBedTop1) {
					this.echartsLeaveBedTop1.resize();
				}
				if (this.echartsLeaveBedTop1) {
					this.echartsLeaveBedTop1.resize();
				}
				if (this.lastThirtyDayLeaveBedChar) {
					this.lastThirtyDayLeaveBedCharts.resize();
				}
			});
		},
		unflodClick() {
			this.isUnfold = !this.isUnfold;
			if (this.isUnfold == true) {
				if (!this.leaveIsShowRightCharts) {
					setTimeout(() => {
						// 最近30天每小时离床情况 - 图表
						if (this.leaveIsShowRightCharts == true) {
							this.setEchartLastThirtyDayLeaveBed();
						}

						// 每晚睡眠间离床情况 - 图表
						this.setEchartLeaveBed();
					}, 300);
				} 
			}
		},
		// 分 转 时分字符串
		mintuesToHoursMintues(data) {
			return (Math.floor(data / 60) < 10 ? '0' + Math.floor(data / 60) : Math.floor(data / 60)) + ':' + ( Math.floor(data % 60) < 10 ? '0' +  Math.floor(data % 60) :  Math.floor(data % 60))
		},
		// 时分字符串 转 分
		hoursMintuesToMintues(data) {
			return (parseInt((parseInt(data.split(":")[0]) * 60) + (parseInt(data.split(":")[1]))))
		},
		// 时分字符串 转 特定时分字符串 （比如：02:00 会变成 26:00）
		hoursMintuesToCustomHoursMintues(data) {
			let mintues = this.hoursMintuesToMintues(data);
			if (mintues < 1170) { // 1170 代表 19:30
				mintues = mintues + 1440;
			}
			return this.mintuesToHoursMintues(mintues);
		},
		leaveChangeDateClick(index) {
			this.leaveSelectIndex = index;
			this.setEchartLeaveBed();
		},
		setEchartLeaveBed() {
			
			if (!this.leaveRightData) {
				this.leaveWidth = 810;
				this.leaveSingleWidth = 27;
			} else {
				this.leaveWidth = 570;
				this.leaveSingleWidth = 19;
			}

			/**
			 * 一、数据处理
			 */
			let xaxisArr = this.leaveLeftData && this.leaveLeftData.xaxis ? this.leaveLeftData.xaxis : [];
			let dataArr = [];
			for (let i = 0; i < this.leaveLeftData.data.length; i++) {
				let item = this.leaveLeftData.data[i];
				dataArr.push(item.extendData.leaveBedCnt);
			}

			// 设置默认选中index
			if (this.leaveSelectIndex === undefined) {
				this.leaveSelectIndex = dataArr.length - 1;
			}

			let xAxis_data = xaxisArr;
			let normal_series_data = []; // 未被选中的柱子数组
			let select_series_data = []; // 被选中的柱子数组
			let tool_series_data = []; // 工具视图（用于处理柱子点击事件和）
			let maxY = 1;
			
			for (let i = 0; i < dataArr.length; i++) {
				// 两个图表 series_data
				if (this.leaveSelectIndex == i) {
					select_series_data.push({
						value: dataArr[i],
						itemStyle: {
							normal: {
								color: this.leaveLeftData.data[i].extendData.leaveBedCntDeviate ? 'rgba(255, 113, 134, 1)' : 'rgba(74, 124, 232, 1)'
							},
							emphasis: {
								color: this.leaveLeftData.data[i].extendData.leaveBedCntDeviate ? 'rgba(255, 113, 134, 1)' : 'rgba(74, 124, 232, 1)'
							}
						}
					});
					normal_series_data.push(null);
				} else {
					select_series_data.push(null);
					normal_series_data.push({
						value: dataArr[i],
						itemStyle: {
							normal: {
								color: this.leaveLeftData.data[i].extendData.leaveBedCntDeviate ? 'rgba(255, 113, 134, 0.1)' : 'rgba(74, 124, 232, 0.1)'
							},
							emphasis: {
								color: this.leaveLeftData.data[i].extendData.leaveBedCntDeviate ? 'rgba(255, 113, 134, 0.4)' : 'rgba(74, 124, 232, 0.4)'
							}
						}
					});
				}
				// Y轴最小值
				if (dataArr[i] > maxY) {
					maxY = dataArr[i];
				}
			}
			for (let i = 0; i < xAxis_data.length; i++) {
				tool_series_data.push(maxY);
			}

			let that = this;

			/**
			 * 设置 Option
			 */
			let option = {
				grid: [
					{ 
						left: 0,
						top: 0,
						right: 0,
						bottom: 2
					},
					{ 
						left: 0,
						top: 0,
						right: 0,
						bottom: 2
					},
					{ 
						left: 0,
						top: 0,
						right: 0,
						bottom: 2
					}
				],
				tooltip: {
					backgroundColor: 'rgba(255, 255, 255, 0.95)',
					borderColor: "rgba(216, 226, 248, 1)",
					borderWidth: 1,
					borderRadius: 4,
					textStyle: {
						color: "#8394B9",
					},
					confine: true,
					formatter: function (value) {

						let barSerieVal = value;

						let titleDiv;
						let contentDiv;
						let dotColor;
						let textColor = 'rgba(165, 169, 188, 1)'

						titleDiv = `<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${that.leaveLeftData.data[barSerieVal.dataIndex].extendData.date}</div>`;

						if (that.leaveLeftData.data[barSerieVal.dataIndex].extendData.leaveBedCntDeviate == true) {
							dotColor = "rgba(255, 113, 134, 1)";
						} else {
							dotColor = "rgba(74, 124, 232, 1)";
						}

						let text = '离床' + that.leaveLeftData.data[barSerieVal.dataIndex].extendData.leaveBedCnt + '次';
						if (that.leaveLeftData.data[barSerieVal.dataIndex].extendData.leaveBedCnt == 0) {
							dotColor = 'rgba(165, 169, 188, 1)'
							text = "未离床"
						} else if (!that.leaveLeftData.data[barSerieVal.dataIndex].extendData.leaveBedCnt) {
							dotColor = 'rgba(165, 169, 188, 1)'
							text = "未使用"
						}
						contentDiv = `
						<div style="display: flex; align-items: center; margin-top: 5px;">
							<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor}'></span>
							<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${text}</div>
						</div>
						`

						return titleDiv + contentDiv

					},
				},
				xAxis: [
					{ 
						gridIndex: 0,
						type: 'category',
						axisTick: {
							show: false,
						},
						axisLine: {
							show: false
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: "rgba(94, 103, 121, 0.1)",
								type: "dotted",
							},
							alignWithLabel: true
						},
						axisLabel: {
							show: false
						},
						data: xAxis_data,
					},
					{ 
						gridIndex: 1,
						type: 'category',
						show: false,
						data: xAxis_data 
					},
					{ 
						gridIndex: 2,
						type: 'category',
						show: false,
						data: xAxis_data 
					}
				],
				yAxis: [
					{ 
						gridIndex: 0,
						minInterval: 1,
						max: maxY,
						axisTick: {
							show: false,
						},
						axisLine: {
							show: false
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: "rgba(94, 103, 121, 0.1)",
								type: "dotted",
							},
						},
						axisLabel: {
							show: false
						},
					},
					{ 
						gridIndex: 1,
						minInterval: 1,
						max: maxY,
						show: false,
					},
					{ 
						gridIndex: 2,
						minInterval: 1,
						max: maxY,
						show: false,
					}
				],
				series: [
					{
						zlevel: 1,
						type: 'bar',
						xAxisIndex: 0,
						yAxisIndex: 0,
						itemStyle: {
							normal: {
							color: 'rgba(74, 124, 232, 0.1)',
							borderRadius: [2, 2, 2, 2],
							},
							emphasis: {
							color: 'rgba(74, 124, 232, 0.4)'
							}
						},
						data: normal_series_data,
					},
					{
						zlevel: 2,
						type: 'bar',
						xAxisIndex: 1,
						yAxisIndex: 1,
						itemStyle: {
							normal: {
							color: 'rgba(74, 124, 232, 0.1)',
							borderRadius: [2, 2, 2, 2],
							},
							emphasis: {
							color: 'rgba(74, 124, 232, 0.4)'
							}
						},
						data: select_series_data,
					},
					{
						zlevel: 0,
						type: 'bar',
						xAxisIndex: 2,
						yAxisIndex: 2,
						itemStyle: {
							normal: {
								color: '#FFFFFF00',
								borderRadius: [2, 2, 2, 2],
							}
						},
						data: tool_series_data,
						barWidth: '100%'
					}
				]
				};

			this.echartsLeaveBedTop1.setOption(option, true);
			this.echartsLeaveBedTop1.resize();

			this.setEchartLeaveBedBottom();
		},
		setEchartLeaveBedBottom() {

			/**
			 * 一、数据处理
			 */

			// 0.数据、X轴
			let leaveLeftData = this.leaveLeftData && this.leaveLeftData.data ? JSON.parse(JSON.stringify(this.leaveLeftData.data)) : null;
			let xaxisArr = this.leaveLeftData && this.leaveLeftData.xaxis ? this.leaveLeftData.xaxis : [];
			// 去掉 timeSt 和 timeEd 的年月日
			for (let i = 0; i < leaveLeftData.length; i++) {
				let item = leaveLeftData[i];
				if (item.extendData && item.extendData.leaveBedList) {
					for (let j = 0; j < item.extendData.leaveBedList.length; j++) {
						let jItem = item.extendData.leaveBedList[j];
						if (jItem.timeSt && jItem.timeSt.indexOf(" ") >= 0) {
							jItem.timeSt = jItem.timeSt.split(" ")[1]
						}
						if (jItem.timeEd && jItem.timeEd.indexOf(" ") >= 0) {
							jItem.timeEd = jItem.timeEd.split(" ")[1]
						}
					}
				}
			}

			let tipWranningList = leaveLeftData[this.leaveSelectIndex];
			if (tipWranningList && tipWranningList.extendData && tipWranningList.extendData.leaveBedList && tipWranningList.extendData.leaveBedList.length > 0) {
				let needArr = [];
				for (let i = 0; i < tipWranningList.extendData.leaveBedList.length; i++) {
					let item = tipWranningList.extendData.leaveBedList[i];
					if (item.floatingWinTips && item.timeSt) {
						let needTop = '0px';
						let tempTimeSt = this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(item.timeSt))
						// 1170
						// 1950
						// 810
						// 313 / 810 = 0.4
						console.log('=======', (tempTimeSt - 1170) * 0.4, tempTimeSt)
						let needArrItem = {
							"floatingWinTips": item.floatingWinTips,
							"top": ((tempTimeSt - 1170) *  0.386 - 20) + 'px'
						}
						needArr.push(needArrItem);
					}
				}
				this.leaveWranningTips = needArr;
			} else { 
				this.leaveWranningTips = []
			}

			// 1.获取Y轴时间点数据（单位：分）
			let yAxis_data = [];
			let start_time_1 = "19:30";
			let end_time_1 = "23:59";
			let start_time_2 = "00:00";
			let end_time_2 = "08:30";
			
			let start_time_1_int = parseInt((parseInt(start_time_1.split(":")[0]) * 60) + (parseInt(start_time_1.split(":")[1])));
			let end_time_1_int = parseInt((parseInt(end_time_1.split(":")[0]) * 60) + (parseInt(end_time_1.split(":")[1])));
			let start_time_2_int = parseInt((parseInt(start_time_2.split(":")[0]) * 60) + (parseInt(start_time_2.split(":")[1])));
			let end_time_2_int = parseInt((parseInt(end_time_2.split(":")[0]) * 60) + (parseInt(end_time_2.split(":")[1])));

			let minutes = [];
			for (let i = start_time_1_int; i <= end_time_1_int; i++) {
				minutes.push(i);
			}
			for (let i = start_time_2_int; i <= end_time_2_int; i++) {
				minutes.push(i);
			}

			// 2.Y轴分段最大值、最小值
			let minY1 = 1170;
			let maxY1 = 1439;
			let minY2 = 0;
			let maxY2 = 510

			// 3.获取最大的堆叠数（堆叠柱状图）
			let maxStackedNum = 0;
			for (let i = 0; i < leaveLeftData.length; i++) {
				let tempItem = leaveLeftData[i];
				if (tempItem && tempItem.extendData.leaveBedList && tempItem.extendData.leaveBedList.length > 0) {
					if (maxStackedNum < tempItem.extendData.leaveBedList.length) {
						maxStackedNum = tempItem.extendData.leaveBedList.length;
					}
				}
			}
			maxStackedNum = maxStackedNum * 2 + 1; // 最大堆叠数计算方式，具体如下
			/**
				0 - 2dict
				1 - 3dict
				2 - 5dict
				3 - 7dict
				4 - 9dict
				5 - 11dict
			*/

			// 拷贝一份新的数据数组，补充满堆叠数
			let copyTargetData = JSON.parse(JSON.stringify(leaveLeftData));
			for (let i = 0; i < copyTargetData.length; i++) {
				let tempItem = copyTargetData[i];
				if (!tempItem.extendData.leaveBedList || tempItem.extendData.leaveBedList.length == 0) {
					tempItem.extendData.leaveBedList = []
					for (let j = 0; j < maxStackedNum; j++) {
						tempItem.extendData.leaveBedList.push(null);
					}
				} else {
					let tempItemTimeDuration = JSON.parse(JSON.stringify(tempItem.extendData.leaveBedList));
					tempItem.extendData.leaveBedList = []
					for (let j = 0; j < maxStackedNum; j++) {
						if (j % 2 == 1) { // 1 3 5 - 0 1 2
							let needIndex = Math.round(j / 2) - 1;
							if (tempItemTimeDuration.length - 1 >= needIndex) {
								tempItem.extendData.leaveBedList.push(tempItemTimeDuration[Math.round(j / 2) - 1]);
							} else {
								tempItem.extendData.leaveBedList.push(null);
							}
						} else {
							tempItem.extendData.leaveBedList.push(null);
						}
					}
				}
			}

			// 再次处理 copyTargetData
			for (let i = 0; i < copyTargetData.length; i++) {
				let tempItem_timeDuration = copyTargetData[i].extendData.leaveBedList;
				for (let j = 0; j < tempItem_timeDuration.length; j++) {
					if (tempItem_timeDuration[j] == null) {
						let needTimeSt;
						let needTimeEd;
						let needDuration;
						let needCustomDuration;
						if (j == 0) {
							needTimeSt = '19:30';
							if (!tempItem_timeDuration[j + 1]) {
								needTimeEd = '19:30'
								needDuration = 0;
								needCustomDuration = 0;
							} else {
								needTimeEd = this.mintuesToHoursMintues((this.hoursMintuesToMintues(tempItem_timeDuration[j + 1].timeSt) - 1));
								needDuration = this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(needTimeEd)) - this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(needTimeSt));
								needCustomDuration = this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(needTimeEd)) - this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(needTimeSt));
							}
							tempItem_timeDuration[j] = {
								'timeSt': needTimeSt,
								'timeEd': needTimeEd,
								'duration': needDuration,
								'needCustomDuration': needCustomDuration,
								'isAdd': true
							}
						} else {
							if (j == tempItem_timeDuration.length - 1) {
								tempItem_timeDuration[j] = {
									'timeSt': tempItem_timeDuration[j - 1].timeEd,
									'timeEd': "08:30",
									'duration': this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues("08:30")) - this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(tempItem_timeDuration[j - 1].timeEd)),
									'needCustomDuration': this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues("08:30")) - this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(tempItem_timeDuration[j - 1].timeEd)),
									'isAdd': true
								}
							} else {
								if (tempItem_timeDuration[j + 1] == null) {
									tempItem_timeDuration[j] = {
										'timeSt': tempItem_timeDuration[j - 1].timeEd,
										'timeEd': tempItem_timeDuration[j - 1].timeEd,
										'duration': 0,
										'needCustomDuration': 0,
										'isAdd': true
									}
								} else {
									let tempLastItem = tempItem_timeDuration[j - 1];
									let tempNextItem = tempItem_timeDuration[j + 1];
									needTimeSt = this.mintuesToHoursMintues(this.hoursMintuesToMintues(tempLastItem.timeEd) + 1);
									needTimeEd = this.mintuesToHoursMintues(this.hoursMintuesToMintues(tempNextItem.timeSt) - 1);
									needDuration = this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(needTimeEd)) - this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(needTimeSt));
									needCustomDuration = this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(needTimeEd)) - this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(needTimeSt));
									tempItem_timeDuration[j] = {
										'timeSt': needTimeSt,
										'timeEd': needTimeEd,
										'duration': needDuration,
										'needCustomDuration': needCustomDuration,
										'isAdd': true
									}
								}
							}
						}
					} else {
						tempItem_timeDuration[j].needCustomDuration =  this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(tempItem_timeDuration[j].timeEd)) - this.hoursMintuesToMintues(this.hoursMintuesToCustomHoursMintues(tempItem_timeDuration[j].timeSt));
						tempItem_timeDuration[j].isAdd = false;
					}
				}
			}

			// console.log('======看看处理好没啊啊=====', copyTargetData)

			// .构造 series 数据
			let series_data = [];
			for (let i = 0; i < maxStackedNum; i++) {
				let serie = {
					xAxisIndex: 0,
					yAxisIndex: 0,
					type: 'bar',
					stack: 'leadve_a',
					barWidth: 5,
					zlevel: 1
				}
				let select_serie = {
					xAxisIndex: 1,
					yAxisIndex: 1,
					type: 'bar',
					stack: 'leave_b',
					barWidth: 13,
					zlevel: 0
				}
				let tempNeedArr = [];
				let select_tempNeedArr = [];
				for (let j = 0; j < copyTargetData.length; j++) {
					let temp_copyTargetData_item = copyTargetData[j];
					let needArrItem = {
						value: i == 0 ? temp_copyTargetData_item.extendData.leaveBedList[i].needCustomDuration + 1170 : temp_copyTargetData_item.extendData.leaveBedList[i].needCustomDuration,
						itemStyle: {
							normal: {
								color: temp_copyTargetData_item.extendData.leaveBedList[i].isAdd ? '#FFFFFF00' : (temp_copyTargetData_item.extendData.leaveBedList[i].deviate ? 'rgba(255, 113, 134, 0.2)' : 'rgba(74, 124, 232, 0.2)'),
								borderRadius: [3, 3, 3, 3]
							},
							emphasis: {
								color: temp_copyTargetData_item.extendData.leaveBedList[i].isAdd ? '#FFFFFF00' : (temp_copyTargetData_item.extendData.leaveBedList[i].deviate ? 'rgba(255, 113, 134, 0.5)' : 'rgba(74, 124, 232, 0.5)'),
								borderRadius: [3, 3, 3, 3]
							},
						},
						customData: temp_copyTargetData_item.extendData.leaveBedList[i]
					}
					tempNeedArr.push(needArrItem)
					
					let select_needArrItem = {
						value: i == 0 ? temp_copyTargetData_item.extendData.leaveBedList[i].needCustomDuration + 1170 : temp_copyTargetData_item.extendData.leaveBedList[i].needCustomDuration,
						itemStyle: {
							normal: {
								color: this.leaveSelectIndex == j ? temp_copyTargetData_item.extendData.leaveBedList[i].isAdd ? '#FFFFFF00' : (temp_copyTargetData_item.extendData.leaveBedList[i].deviate ? 'rgba(255, 113, 134, 1)' : 'rgba(74, 124, 232, 1)') : '#FFFFFF00',
								borderRadius: [3, 3, 3, 3]
							},
							emphasis: {
								color: this.leaveSelectIndex == j ? temp_copyTargetData_item.extendData.leaveBedList[i].isAdd ? '#FFFFFF00' : (temp_copyTargetData_item.extendData.leaveBedList[i].deviate ? 'rgba(255, 113, 134, 1)' : 'rgba(74, 124, 232, 1)') : '#FFFFFF00',
								borderRadius: [3, 3, 3, 3]
							},
						},
						customData: temp_copyTargetData_item.extendData.leaveBedList[i]
					}
					select_tempNeedArr.push(select_needArrItem)
				}
				serie.data = tempNeedArr;
				series_data.push(serie);

				select_serie.data = select_tempNeedArr;
				series_data.push(select_serie);
			}

			let option2 = {
				tooltip: {
					backgroundColor: 'rgba(255, 255, 255, 0.95)',
					borderColor: "rgba(216, 226, 248, 1)",
					borderWidth: 1,
					borderRadius: 4,
					textStyle: {
						color: "#8394B9",
					},
					confine: true,
					formatter: function (value) {
						let barSerieVal = value;


						if (!value.data.customData.isAdd) {
							let titleDiv;
							let contentDiv;
							let dotColor;
							let textColor = 'rgba(165, 169, 188, 1)'

							if (value.data.customData.deviate == true) {
								textColor = 'rgba(255, 113, 134, 1)';
								dotColor = "rgba(255, 113, 134, 1)";
							} else {
								textColor = 'rgba(165, 169, 188, 1)';
								dotColor = "rgba(74, 124, 232, 1)";
							}

							titleDiv = `<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${value.data.customData.timeStCn}</div>`;

							contentDiv = `
							<div style="display: flex; align-items: center; margin-top: 5px;">
								<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor}'></span>
								<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${'离床' + value.data.customData.duration + '分钟'}</div>
							</div>
							`

							return titleDiv + contentDiv
						} else {
							return undefined
							return `<div></div>`
							let titleDiv;
							let textColor = 'rgba(165, 169, 188, 1)'
							titleDiv = `<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'></div>`;
							return titleDiv
						}

					},
				},
				grid: [
					{ 
						left: 0,
						top: 0,
						right: 0,
						bottom: 2,
					},
					{ 
						left: 0,
						top: 0,
						right: 0,
						bottom: 2
					},
				],
				xAxis: [
					{
						gridIndex: 0,
						type: 'category',
						axisTick: {
							show: false,
						},
						axisLine: {
							show: false
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: "rgba(94, 103, 121, 0.1)",
								type: "dotted",
							},
							alignWithLabel: true
						},
						data: xaxisArr
					},
					{
						gridIndex: 1,
						type: 'category',
						show: false,
						data: xaxisArr
					}
				],
				yAxis: [
					{
						gridIndex: 0,
						type: 'value',
						axisTick: {
							show: false,
						},
						axisLine: {
							show: false
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: "rgba(94, 103, 121, 0.1)",
								type: "dotted",
							},
						},
						min: 1170,
						max: 1950,
						inverse: true,
						interval: 60,
					},
					{
						gridIndex: 1,
						type: 'value',
						show: false,
						min: 1170,
						max: 1950,
						inverse: true
					}
				],
				series: series_data
			};
			this.echartsLeaveBedBottom1.setOption(option2, true);
			this.echartsLeaveBedBottom1.resize();
		},
		// 最近30天每小时离床情况 Echarts 图表
		setEchartLastThirtyDayLeaveBed() {
			
			let interfaceData = JSON.parse(JSON.stringify(this.leaveRightData))

			let originalDataArr = interfaceData.last30EveryHourList;
			let barArr = [];
			let lineArr = [];
			for (let i = 0; i < originalDataArr.length; i++) {
				let item = originalDataArr[i];
				barArr.push(item.cnt);
				lineArr.push(item.duration);
			}

			// pieces
			let pieces = [];
			for (let i = 0; i < originalDataArr.length; i++) {
				let item = originalDataArr[i];
				if (item.duration == 0) {
					pieces.push(
						{
							gt: i - 1,
							lte: i,
							symbolSize: 6,
							color: 'rgba(165, 169, 188, 1)'
						}
					)
				} else {
					pieces.push(
						{
							gt: i - 1,
							lte: i,
							symbolSize: 6,
							color: 'rgba(110, 197, 245, 1)'
						}
					)
				}
			}

			// let yAxis_data = ["19:30", "20:00", "20:30", "21:00", "21:30", "22:00", "22:30", "23:00", "23:30", "00:00", "00:30", "01:00", "01:30", "02:00", "02:30", "03:00", "03:30", "04:00", "04:30", "05:00", "05:30", "06:00", "06:30", "07:00", "07:30", "08:00", "08:30"]
			let yAxis_data = ['19:30~20:30', '20:30~21:30', '21:30~22:30', '22:30~23:30', '23:30~00:30', '00:30~01:30', '01:30~02:30', '02:30~03:30', '03:30~04:30', '04:30~05:30', '05:30~06:30', '06:30~07:30', '07:30~08:30']
			let option = {
				grid: [
					{
						x: -3,
						y: 0,
						x2: 0,
						y2: 0,
						containLabel: true
					},
					{
						x: -3,
						y: 0,
						x2: 0,
						y2: 0,
						containLabel: true
					}
				],
				tooltip: {
					trigger: "axis",
					backgroundColor: 'rgba(255, 255, 255, 0.95)',
					borderColor: "rgba(216, 226, 248, 1)",
					borderWidth: 1,
					borderRadius: 4,
					textStyle: {
						color: "#8394B9",
					},
					confine: true,
					formatter: function (value) {

						let barSerieVal = value[0];
						let lineSerieVal = value[1];

						let titleDiv;
						let contentDiv1;
						let contentDiv2;
						let contentDiv3;
						let dotColor1;
						let dotColor2;
						let dotColor3;
						let textColor = 'rgba(165, 169, 188, 1)'

						titleDiv = `<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${'最近30天'} ${originalDataArr[barSerieVal.dataIndex].timeSt + '～' + originalDataArr[barSerieVal.dataIndex].timeEd}</div>`;
						if (!barSerieVal.data || barSerieVal.data == 0) {
							dotColor3 = 'rgba(165, 169, 188, 1)';
							contentDiv3 = `
							<div style="display: flex; align-items: center; margin-top: 5px;">
								<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor3}'></span>
								<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${'未离床'}</div>
							</div>
							`
							return titleDiv + contentDiv3;
						} else {
							dotColor1 = 'rgba(74, 124, 232, 1)';
							dotColor2 = 'rgba(110, 197, 245, 1)';
							contentDiv1 = `
							<div style="display: flex; align-items: center; margin-top: 5px;">
								<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor1}'></span>
								<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${'离床' + barSerieVal.data + '次'}</div>
							</div>
							`
							contentDiv2 = `
							<div style="display: flex; align-items: center; margin-top: 5px;">
								<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor2}'></span>
								<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${'平均离床' + lineSerieVal.data + '分钟/次'}</div>
							</div>
							`
							return titleDiv + contentDiv1 + contentDiv2;
						}

						// let barValue = value

						// let dotColor = 'rgba(74, 124, 232, 1)';
						// let textColor = 'rgba(131, 148, 185, 1)';

						// // 弹窗样式
						// let titleDiv = `<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${'2'} ${'1'}</div>`
						// let contentDiv1 = `
						// <div style="display: flex; align-items: center; margin-top: 5px;">
						// 	<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor}'></span>
						// 	<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${'hahahahaha'}</div>
						// </div>
						// `
						// let contentDiv2 = `
						// <div style="display: flex; align-items: center; margin-top: 5px;">
						// 	<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor}'></span>
						// 	<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${'hahahahaha'}</div>
						// </div>
						// `
						// return titleDiv + contentDiv1 + contentDiv2;

						// let tempArr = expansion_data[value[0].dataIndex] || []
						// if (!tempArr || tempArr.length == 0) {
						// 	return
						// }
						// let startTime = parseInt(value[0].name);
						// let endTime = startTime + 9;
						// let startHours = Math.floor(startTime / 60);
						// let startHoursStr = startHours < 10 ? '0' + startHours : startHours;
						// let startMinutes = startTime - (startHours * 60);
						// let startMinutesStr = startMinutes < 10 ? '0' + startMinutes : startMinutes;
						// let endHours = Math.floor(endTime / 60);
						// let endHoursStr = endHours < 10 ? '0' + endHours : endHours;
						// let endMinutes = endTime - (endHours * 60);
						// let endMinutesStr = endMinutes < 10 ? '0' + endMinutes : endMinutes;
						// let topStr1 = startHoursStr + ':' + startMinutesStr + '～' + endHoursStr + ':' + endMinutesStr + ' 发生';
						// let topStr2 = value[0].value;
						// let bottomStr = '';
						// for (let i = 0; i < tempArr.length; i++) {
						// 	let item = tempArr[i];
						// 	if (i == 0) {
						// 		bottomStr += item;
						// 	} else {
						// 		bottomStr = bottomStr + '、' + item;
						// 	}
						// }
						
						// let divStr = "<div style='display: flex; flex-direction: column;'><div style='display: flex;'><div style='font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px;'>" + topStr1 + "</div><div style='font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: rgba(255, 113, 134, 1); line-height: 17px;'>" + topStr2 + "</div><div style='font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px;'>次</div></div><div style='display: flex; margin-top: 2px;'><div style='width: 6px; height: 6px; background: #4A7CE8; border-radius: 3px; margin-top: 6px;'></div><div style='flex: 1; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px; margin-left: 4px; max-width: 285px; white-space: wrap;'>" + bottomStr + "</div></div></div>"
						// return divStr;
						// return "<div style='display: flex; flex-direction: column;'><div style='display: flex;'><div style='font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px;'>04:01～04:10 发生</div><div style='font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: rgba(255, 113, 134, 1); line-height: 17px;'>9</div><div style='font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px;'>次</div></div><div style='display: flex; margin-top: 2px;'><div style='width: 6px; height: 6px; background: #4A7CE8; border-radius: 3px; margin-top: 6px;'></div><div style='flex: 1; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 17px; margin-left: 4px; width: 264px; white-space: wrap;'>04:01～04:01、04:02～04:02、04:03～04:03、04:04～04:04、04:05～04:05、04:06～04:06、04:07～04:07、04:08～04:08、04:09～04:12</div></div></div>";
					},
				},
				xAxis: [
					{
						gridIndex: 0,
						axisTick: {
							show: false,
						},
						axisLabel: {
							show: false
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: "rgba(144, 148, 166, 0.1)",
								type: "solid",
							},
						},
						splitLine: {
							show: false
						},
					},
					{
						gridIndex: 1,
						axisTick: {
							show: false,
						},
						axisLabel: {
							show: false
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: "rgba(144, 148, 166, 0.1)",
								type: "solid",
							},
						},
						splitLine: {
							show: false
						},
					}
				],
				yAxis: [
					{
						gridIndex: 0,
						data: yAxis_data,
						axisTick: {
							show: false,
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: "rgba(165, 169, 188, 1)", //坐标的字体颜色
								fontSize: 10
							},
							formatter: function () {
								return "";
							},
						},
						axisLine: {
							show: false
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: "rgba(94, 103, 121, 0.1)",
								type: "dotted",
							},
						},
						inverse: true
					},
					{
						gridIndex: 1,
						data: yAxis_data,
						axisTick: {
							show: false,
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: "rgba(165, 169, 188, 1)", //坐标的字体颜色
								fontSize: 10
							},
							formatter: function () {
								return "";
							},
						},
						axisLine: {
							show: false
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: "rgba(94, 103, 121, 0.1)",
								type: "dotted",
							},
						},
						inverse: true
					}
				],
				visualMap: {
					show: false,
					seriesIndex: 1,
					pieces: pieces
				},
				series: [
					{
						type: 'bar',
						xAxisIndex: 0,
						yAxisIndex: 0,
						data: barArr,
						barWidth: 13,
						itemStyle: {
							normal: {
								barBorderRadius: [1, 1, 1, 1],
								color: '#4A7CE8'
							}
						},
					},
					{
						type: 'line',
						xAxisIndex: 1,
						yAxisIndex: 1,
						symbol: 'circle',
						itemStyle: {
						color: 'orange'
						},
						lineStyle: {
						color: 'rgba(110, 197, 245, 1)',
						width: 1
						},
						data: lineArr
					}
				]
			};
			this.lastThirtyDayLeaveBedCharts.setOption(option, true);
			this.lastThirtyDayLeaveBedCharts.resize();
		},
	},
};
</script>
<style lang="scss" scoped>
.miniCard ::v-deep {
	background: #ECF0F3;

	.unfoldImgTrue {
		background: url('../../../assets/icon_common_special_arrow_10.png') no-repeat no-repeat;
		background-size: contain;
	}

	.unfoldImgFalse {
		background: url('../../../assets/icon_common_special_arrow_9.png') no-repeat no-repeat;
		background-size: contain;
	}

	.richContentStyle {
		display: flex;
	}

	.richTextStyleNormal {
		font-size: 18px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: rgba(31, 38, 53, 1);
		line-height: 25px;
	}

	.richTextStyleRed {
		font-size: 18px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: rgba(255, 113, 134, 1);
		line-height: 25px;
	}
}

.miniCard:hover {
	background: rgba(223, 232, 252, 1) !important;

	.unfoldImgTrue {
		background: url('../../../assets/icon_common_special_arrow_12.png') no-repeat no-repeat;
		background-size: contain;
	}

	.unfoldImgFalse {
		background: url('../../../assets/icon_common_special_arrow_11.png') no-repeat no-repeat;
		background-size: contain;
	}
}

.miniCardTop {
	background: rgba(255, 255, 255, 0.85);
	border-radius: 12px;
	border: 1px solid #FFFFFF;
	display: flex;
	flex-direction: column;
	padding-top: 12px;
	padding-bottom: 15px;
	margin: 5px;
}

.leaveBed ::v-deep {
	.richContentStyle {
		display: block;
		// white-space: nowrap;
		// height: 20px;
		// text-overflow: ellipsis;
		// overflow: hidden;
	}
	.richTextStyleNormal {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: #5E6779;
		line-height: 20px;
		// white-space: nowrap;
		display: inline;
	}
	.richTextStyleRed {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: rgba(255, 113, 134, 1);
		line-height: 20px;
		// white-space: nowrap;
		display: inline;
	}

	.richContentStyleTip {
		display: block;
		white-space: wrap;
		// max-width: 100px;
		overflow-wrap: break-word;
	}
	.richTextStyleTipNormal {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: #5E6779;
		line-height: 20px;
		// white-space: nowrap;
		display: inline;
	}
	.richTextStyleTipRed {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: rgba(255, 113, 134, 1);
		line-height: 20px;
		// white-space: nowrap;
		display: inline;
	}
}

</style>
  